// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.styles_title__MOuIe {
  align-items: center;
  color: #18316e;
  display: flex;
  flex: 1 1;
  font-family: "Abhaya Libre";
  font-size: 2rem;
  font-weight: 600;
  gap: 15px;
}

.styles_container_btn__ySwg\\+ {
  display: flex;
  justify-content: space-between;
  align-items: center;
  width: 100%;
  padding: 15px;
  gap: 20px;
}

.styles_actions__modalContratos__1PBD\\+ {
  display: flex;
  gap: 20px;
}

@media (max-width: 768px) {
  .styles_container_btn__ySwg\\+ {
    flex-direction: column-reverse;
  }

  .styles_actions__modalContratos__1PBD\\+ {
    flex-direction: column-reverse;
  }
}
`, "",{"version":3,"sources":["webpack://./src/pages/Juridico/ModalContratos/styles.module.css"],"names":[],"mappings":"AAAA;EACE,mBAAmB;EACnB,cAAc;EACd,aAAa;EACb,SAAO;EACP,2BAA2B;EAC3B,eAAe;EACf,gBAAgB;EAChB,SAAS;AACX;;AAEA;EACE,aAAa;EACb,8BAA8B;EAC9B,mBAAmB;EACnB,WAAW;EACX,aAAa;EACb,SAAS;AACX;;AAEA;EACE,aAAa;EACb,SAAS;AACX;;AAEA;EACE;IACE,8BAA8B;EAChC;;EAEA;IACE,8BAA8B;EAChC;AACF","sourcesContent":[".title {\n  align-items: center;\n  color: #18316e;\n  display: flex;\n  flex: 1;\n  font-family: \"Abhaya Libre\";\n  font-size: 2rem;\n  font-weight: 600;\n  gap: 15px;\n}\n\n.container_btn {\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n  width: 100%;\n  padding: 15px;\n  gap: 20px;\n}\n\n.actions__modalContratos {\n  display: flex;\n  gap: 20px;\n}\n\n@media (max-width: 768px) {\n  .container_btn {\n    flex-direction: column-reverse;\n  }\n\n  .actions__modalContratos {\n    flex-direction: column-reverse;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"title": `styles_title__MOuIe`,
	"container_btn": `styles_container_btn__ySwg+`,
	"actions__modalContratos": `styles_actions__modalContratos__1PBD+`
};
export default ___CSS_LOADER_EXPORT___;
